import { Space } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { ModelLink } from "@/modules/model-link";

const RecommendedBy = ({ recommendedBy, loading }) => {
  const { t } = useTranslation();

  if (!recommendedBy || loading) return null;

  const firstObservation = recommendedBy.observations?.[0];

  return (
    <Space>
      {t("recommendation:recommendedBy.label")}
      <ModelLink
        model="intervention"
        item={recommendedBy}
        search={`?observation_id=${firstObservation}`}
      />
    </Space>
  );
};

RecommendedBy.propTypes = {
  recommendedBy: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    state: PropTypes.string,
    observations: PropTypes.arrayOf(PropTypes.number),
  }),
  loading: PropTypes.bool,
};

export default RecommendedBy;
